module.exports = __webpack_public_path__ + "img/GALLERY-BALENO-6.18acf67b.jpg";